import './footer.css'
import iconInstagram from "../../../../assets/features/workplace/icons/instagram.svg";
import iconTwitter from "../../../../assets/features/workplace/icons/twitter.svg";
import imageFooter from "../../../../assets/features/workplace/images/imageFooter.png";
import {LanguageSwitch} from "@/components/language-switch/language-switch.tsx";

function Footer() {

    return (
        <footer>
            <div className="contentFooter">
                <img src={imageFooter} alt="Some background" className="footerImage"></img>
                <div className="footerMenu">
                    <div className="footerMenuItemColumn">
                        <h2>Navigation</h2>
                        <a href={`/home`}>Home</a>
                        <a href={`/shop`}>Shop</a>
                        <a href={`/company`}>Company</a>
                        <a href={`/stories`}>Stories</a>
                    </div>

                    <div className="footerMenuItemColumn">
                        <h2>Kundenservice</h2>
                        <a href={`/contact`}>Kontakt</a>
                        <a href={`/faq`}>FAQ-Häufig gestellte Fragen</a>
                    </div>

                    <div className="footerMenuItemColumn">
                        <h2>Informationen</h2>
                        <a href={`/impressum`}>Impressum</a>
                        <a href={`/terms-and-conditions`}>AGB</a>
                    </div>

                    <div className="footerMenuItemColumn">
                        <h2>SUUS</h2>
                        <span>Musterstrasse 23</span>
                        <span>8888 Zürich</span>
                        <span>Switzerland</span>
                    </div>
                </div>
            </div>

            <div className="contentFooterBottom">
                <div className="contentFooterCopyright">
                    Copyright © 2020 SUUS Innovations. All rights reserved.
                </div>
                <LanguageSwitch/>
                <div className="contentFooterSocialMedia">
                    <a href={`/home`}>
                        <img src={iconInstagram} className="icon" alt="Instagram"/>
                    </a>
                    <a href={`/home`}>
                        <img src={iconTwitter} className="icon" alt="Twitter"/>
                    </a>
                </div>
            </div>
        </footer>
    )
}

export default Footer
